import request from 'utils/request';
import config from 'config/Config';

export default class {
  //客户数据列表
  static getCustomerList(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: 'customer/customer/team/group',
      params
    });
  }

  /**
   * 获取客户分群
   */
  static getTeamGroupList() {
    return request({
      host: config.HOST_PROMOTE,
      url: 'customer/tagger/getTaggerStatisticList'
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Promote/Schedule/NewAdd/RemindCustomer/RemindCustomerServ.js